import { render, staticRenderFns } from "./DepartListSync.vue?vue&type=template&id=23dcefa8&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./DepartListSync.vue?vue&type=script&lang=js&"
export * from "./DepartListSync.vue?vue&type=script&lang=js&"
import style0 from "./DepartListSync.vue?vue&type=style&index=0&id=23dcefa8&prod&scoped=true&lang=css&"
import style1 from "./DepartListSync.vue?vue&type=style&index=1&id=23dcefa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dcefa8",
  null
  
)

export default component.exports